import { get } from 'lodash-es'
import { actionNames } from './actions'

const initialState = {
  notification: {},
  siteData: {},
  siteSettings: [],
  criticalErrorMessage: null,
}

const defaultDateFormat = 'MMMM DD, YYYY'
const defaultTimeFormat = 'HH:mm'

const dateFormatterMap = {
  '%q': defaultDateFormat,
  '%Q': 'dddd MMMM DD, YYYY',
  '%D': 'DD/MM/YY',
  '%d.%m.%Y.': 'DD.MM.YYYY.',
  '%Y.%m.%d.': 'YYYY.MM.DD.',
  '%d-%m-%Y': 'DD-MM-YYYY',
  '%F': 'YYYY-MM-DD',
  '%m/%d/%y': 'MM/DD/YY',
  '%m/%d/%Y': 'MM/DD/YYYY',
  '%m-%d-%Y': 'MM-DD-YYYY',
  '%m.%d.%Y': 'MM.DD.YYYY',
}

const timeFormatterMap = {
  '%H:%M': defaultTimeFormat,
  '%r': 'hh:mm A',
  '%T': 'HH:mm:ss',
}

const addTimeFormat = (data) => {
  const dateFormat = get(dateFormatterMap, data.date_format, defaultDateFormat)
  const timeFormat = get(timeFormatterMap, data.time_format, defaultTimeFormat)

  return { dateFormat, timeFormat }
}

const getSiteData = (siteData) => ({
  ...siteData,
  ...addTimeFormat(siteData),
})

export default function appReducers(state = initialState, action) {
  switch (action.type) {
    case actionNames.INIT_APP_SUCCESS: {
      const siteData = action.data.site
      return {
        ...state,
        siteData: getSiteData(siteData),
      }
    }
    case actionNames.REFETCH_SITE_DATA_SUCCESS: {
      const siteData = action.data.site
      return {
        ...state,
        siteData: getSiteData(siteData),
      }
    }
    case actionNames.FETCH_SETTINGS_SUCCESS: {
      return {
        ...state,
        siteSettings: action.settings,
      }
    }
    case actionNames.SHOW_CRITICAL_ERROR: {
      return {
        ...state,
        criticalErrorMessage: action.message,
      }
    }
    case actionNames.RESET_CRITICAL_ERROR: {
      return {
        ...state,
        criticalErrorMessage: null,
      }
    }
    case actionNames.NOTIFICATION_SHOW:
      return { ...state, notification: action.notification }
    case actionNames.PERSISTENT_NOTIFICATION_SHOW:
      return { ...state, persistentNotification: action.notification }
    default:
      return state
  }
}
